import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    starts: String,
    ends: String,
  }

  static targets = [
    'dateField',
    'startsAt',
    'codeField',
    'dateChecked',
    'duration',
    'startsNil',
    'endsNil',
    'timezone',
  ]

  startsAtTargetConnected = (element) => {
    element.addEventListener('change', () => {
      const [startsAtEl, endsAtEl] = this.dateFieldTargets

      this.syncEndDateMin(startsAtEl, endsAtEl)
    })
  }

  connect = () => {
    if (this.hasCodeFieldTarget) {
      this.placeholderCode = this.codeFieldTarget.value
    }
    if (this.hasTimezoneTarget && this.hasDateCheckedTarget && this.dateCheckedTarget.checked) {
      this.timezoneTarget.required = true
    }
  }

  toggleDate = () => {
    console.log('hereher')
    const [startsAtEl, endsAtEl] = this.dateFieldTargets

    if (this.dateCheckedTarget.checked) {
      this.startsNilTarget.disabled = true
      this.endsNilTarget.disabled = true
      startsAtEl.disabled = false
      endsAtEl.disabled = false
      if (this.hasTimezoneTarget) this.timezoneTarget.required = true

      this.syncEndDateMin(startsAtEl, endsAtEl)
      // enable the flatpickr alt inputs too
      if (startsAtEl?._flatpickr) {
        startsAtEl._flatpickr.altInput.disabled = false
        startsAtEl._flatpickr.setDate(this.startsValue)
      }
      if (endsAtEl?._flatpickr) {
        endsAtEl._flatpickr.altInput.disabled = false
        endsAtEl._flatpickr.setDate(this.endsValue)
      }
      this.durationTarget.classList.remove('hidden')
    }
    else {
      this.startsNilTarget.disabled = false
      this.endsNilTarget.disabled = false
      startsAtEl.disabled = true
      endsAtEl.disabled = true
      if (startsAtEl?._flatpickr) startsAtEl._flatpickr.altInput.disabled = true
      if (endsAtEl?._flatpickr) endsAtEl._flatpickr.altInput.disabled = true
      if (this.hasTimezoneTarget) this.timezoneTarget.required = false
      this.durationTarget.classList.add('hidden')
    }
  }

  syncEndDateMin = (startsAtEl, endsAtEl) => {
    if (!startsAtEl?._flatpickr || !endsAtEl?._flatpickr) return

    // Set initial minDate based on current start value
    const currentStart = startsAtEl._flatpickr.selectedDates[0]
    if (currentStart) {
      endsAtEl._flatpickr.set('minDate', currentStart)
    }

    // Update minDate whenever start changes
    startsAtEl._flatpickr.config.onChange.push((selectedDates) => {
      if (selectedDates[0]) {
        endsAtEl._flatpickr.set('minDate', selectedDates[0])

        // If end date is now before start, clear it
        const endDates = endsAtEl._flatpickr.selectedDates
        if (endDates[0] && endDates[0] < selectedDates[0]) {
          endsAtEl._flatpickr.clear()
        }
      }
    })
  }

  roundDownToHour = (date) => {
    const d = new Date(date)
    d.setMinutes(0, 0, 0)
    return d
  }
}
